export const STATE_NAME = 'guruWidget'

const OPEN_STORAGE_KEY = 'guru.widget.open.v1'
const POSITION_STORAGE_KEY = 'guru.widget.position.v1'

const readBool = (key, fallback) => {
  try {
    const raw = window.localStorage.getItem(key)
    if (raw === null) return fallback
    return raw === '1'
  } catch (_) {
    return fallback
  }
}

const readPosition = () => {
  try {
    const raw = window.localStorage.getItem(POSITION_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && Number.isFinite(parsed.right) && Number.isFinite(parsed.bottom)) {
      return { right: parsed.right, bottom: parsed.bottom }
    }
    return null
  } catch (_) {
    return null
  }
}

export const persistOpen = (open) => {
  try { window.localStorage.setItem(OPEN_STORAGE_KEY, open ? '1' : '0') } catch (_) {}
}

export const persistPosition = (position) => {
  try {
    if (position) {
      window.localStorage.setItem(POSITION_STORAGE_KEY, JSON.stringify(position))
    } else {
      window.localStorage.removeItem(POSITION_STORAGE_KEY)
    }
  } catch (_) {}
}

export const initialState = {
  open: typeof window !== 'undefined' ? readBool(OPEN_STORAGE_KEY, false) : false,
  view: 'suggestions',
  anchorContext: null,
  entityAttachment: null,
  prefilledInput: '',
  position: typeof window !== 'undefined' ? readPosition() : null,
  overrideScope: null,
}
